import { useMutation } from "react-query";
import { useApiError } from "src/hooks/useApiError";
import { createServiceSite } from "src/service/pay";

interface IUseCreateServicePromotionAskProps {
  onSuccess?: () => void;
  onError?: (error: any) => void;
}

// 프리미엄코드 문의하기 요청
const useCreateServiceSite = ({
  onSuccess,
  onError,
}: IUseCreateServicePromotionAskProps) => {
  const { handleError } = useApiError();
  const {
    mutate: mutateCreateServiceSite,
    isLoading: isCreateServiceSiteLoading,
  } = useMutation({
    mutationFn: createServiceSite,
    onSuccess: onSuccess ? onSuccess : (res) => {},
    onError: onError ? onError : handleError,
  });
  return { mutateCreateServiceSite, isCreateServiceSiteLoading };
};

export default useCreateServiceSite;
